import { useAuth } from "@mindlercare/auth-ui";
import { useDemo, useToggleDemo } from "contexts/DemoContext";
import { useSlotDialogParam } from "hooks/useSlotDialogParam";
import { useCallback } from "react";
import { Navbar } from "../navbar";
import { useMindlerApi } from "../../api/apiv2";

import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;

const convertUTCDateToUnixTimestamp = (date: string) =>
  new Date(date).getTime() / 1000;

type UTCStringTimestampData = {
  startsAt: string;
  endsAt: string;
  canceledAt: string | null;
};

const convertTimestamps = (data: UTCStringTimestampData) => ({
  startsAt: convertUTCDateToUnixTimestamp(data.startsAt),
  endsAt: convertUTCDateToUnixTimestamp(data.endsAt),
  canceledAt: data.canceledAt
    ? convertUTCDateToUnixTimestamp(data.canceledAt)
    : null,
});

export const Header = () => {
  const { userId, isLoggedIn } = useAuth();
  const mindlerApiV2 = useMindlerApi();
  const { data: nextPatientSlot } = useQuery(
    mindlerApiV2.psychologists.getNextBookedSlot.queryOptions(
      {
        psychologistUserId: userId as number, // safe to cast since we use enabled !!userId
      },
      {
        enabled: !!userId,
        select: (data) => {
          if (data === undefined || data === null) return undefined;
          return {
            ...data,
            ...convertTimestamps(data),
          };
        },
      },
    ),
  );

  const hideSensitiveInformation = useDemo();
  const toggleDemo = useToggleDemo();
  const [, setSlotIdParam] = useSlotDialogParam();

  const handleNextSlotOpen = useCallback(() => {
    if (!nextPatientSlot) return;
    setSlotIdParam(nextPatientSlot.slotId);
  }, [setSlotIdParam, nextPatientSlot]);

  const toggleSensitiveInformation = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.preventDefault();
      toggleDemo();
    },
    [toggleDemo],
  );

  return isLoggedIn ? (
    <Navbar
      nextPatientSlot={nextPatientSlot}
      handleNextMeetingClick={handleNextSlotOpen}
      handleHideSensitiveInformation={toggleSensitiveInformation}
      hideSensitiveInformation={hideSensitiveInformation}
    />
  ) : null;
};
